/* eslint-disable no-console */
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import CustomModal from "../../Core/Components/Modal/CustomModal";
import CustomRoundedImage from "../../Core/Components/CustomRoundedImage";
import SessionIcon from "../../Common/Svgs/SessionIcon";
import CloseIcon from "../../Common/Svgs/CloseIcon";
import Button from "../../Core/Components/CustomButton";
import { updateSession } from "../../Redux/Slices/sessions.slice";
import {
  endSessionByAdmin,
  getSessionKPI,
  getSessions,
} from "../../Redux/APIs/sessionsAPI";
import { SESSION_STATUS } from "./constants";
import { DEFAULT_LIMIT } from "../../Utils/constants";

const CompleteSessionModal = ({
  visible,
  onCancel,
  currentPage = 1,
  pageSize = DEFAULT_LIMIT,
  filters = {},
  search = "",
}) => {
  const dispatch = useDispatch();
  const [btnLoading, setBtnLoading] = useState(false);

  const { completeSessionModal } = useSelector((state) => state.sessions);
  const session = completeSessionModal?.session || {};

  const onConfirm = async () => {
    try {
      setBtnLoading(true);
      await dispatch(endSessionByAdmin({ sessionId: session.id })).unwrap();

      const filterObj = {
        offset: ((currentPage || 1) - 1) * pageSize,
        limit: pageSize,
      };
      if (search) filterObj.searchQuery = search;
      if (filters.hubs?.length) filterObj.hubs = filters.hubs;
      if (filters.agents?.length) filterObj.agents = filters.agents;
      if (filters.status?.length) filterObj.status = filters.status;
      if (filters.type?.length) filterObj.type = filters.type;

      await dispatch(getSessions(filterObj)).unwrap();
      dispatch(getSessionKPI());

      dispatch(
        updateSession({
          key: "showToastMessage",
          value: {
            visible: true,
            data: {
              title: "Session override",
              description: `Session ${session.id} was marked as completed manually`,
            },
          },
        }),
      );

      onCancel();
    } catch (error) {
      console.error(error);
      onCancel();
    } finally {
      setBtnLoading(false);
    }
  };

  const sessionStatusText =
    session.status === SESSION_STATUS.ONGOING ? "ongoing" : "upcoming";

  return (
    <CustomModal visible={visible} onCancel={onCancel} width="536px" centered>
      <div className="w-full p-4 rounded-md">
        <div className="flex items-center justify-between">
          <div className="relative">
            <CustomRoundedImage
              size="w-12 h-12"
              image={<SessionIcon size={24} className="text-white" />}
              background="bg-primary"
            />
          </div>
          <button type="button" onClick={onCancel}>
            <CloseIcon className="w-6 h-6 stroke-dark-gray" />
          </button>
        </div>

        <div className="px-2 mt-5">
          <p className="text-base font-medium text-black font-poppins">
            Complete session
          </p>
          <p className="mt-2 text-xs font-normal text-black font-aileron">
            Are you sure you want to complete this {sessionStatusText} session?
          </p>
        </div>

        <div className="flex justify-end gap-x-3 mt-5.5">
          <Button colors="cancelButton" size="primary" onClick={onCancel}>
            Cancel
          </Button>
          <Button
            colors="primary"
            size="primary"
            onClick={onConfirm}
            disabled={btnLoading}
          >
            Mark as Completed
          </Button>
        </div>
      </div>
    </CustomModal>
  );
};

export default CompleteSessionModal;
